<template>
  <div class="form-group row">
    <div class="col-md-3">
      <label for="txtCodeSinister">{{$lang.Sinister.Details.SinisterCode}}:</label>
      <div class="input-group">
        <b-form-input type="text"
                      name="txtCodeSinister"
                      :placeholder="$lang.Sinister.Details.SinisterCode"
                      v-model="form.sinisterCode.value"
                      :size="form.sinisterCode.maxlength"
                      :required="form.sinisterCode.required"
                      :state="form.sinisterCode.state"
                      :disabled="true"/>
      </div>
    </div>
    <div class="col-md-1">
      <label for="txtSinisterVersion">{{$lang.Sinister.Details.Version}}:</label>
      <div class="input-group">
        <b-form-input type="text"
                      name="txtSinisterVersion"
                      :placeholder="'0'"
                      v-model="form.sinisterVersion.value"
                      :size="form.sinisterVersion.maxlength"
                      :required="form.sinisterVersion.required"
                      :state="form.sinisterVersion.state"
                      :disabled="true"/>
      </div>
    </div>
    <div class="col-md-4">
      <label for="txtInsurer">{{$lang.Sinister.Details.Insurer}}:</label>
      <div class="input-group">
        <b-form-input type="text"
                      name="txtInsurer"
                      :placeholder="$lang.Sinister.Details.PlaceholderInsurerName"
                      v-model="form.insurance.value"
                      :size="form.insurance.maxlength"
                      :required="form.insurance.required"
                      :state="form.insurance.state"
                      :disabled="true"/>
      </div>
    </div>
    <div class="col-md-4">
      <label for="txtInsured">{{$lang.Sinister.Details.Insured}}:</label>
      <div class="input-group">
        <b-form-input type="text"
                      name="txtInsured"
                      :placeholder="$lang.Sinister.Details.PlaceholderInsuredName"
                      v-model="form.insured.value"
                      :size="form.insured.maxlength"
                      :required="form.insured.required"
                      :state="form.insured.state"
                      :disabled="true"/>
      </div>
    </div>
  </div>
</template>
<script>
import SinisterHeader from './sinisterheader.js'
export default SinisterHeader
</script>



// WEBPACK FOOTER //
// src/components/regulation/auto/sinisterheader/sinisterheader.vue